import { ResponsiveImage } from 'components/Global/ResponsiveImage'

import Link from 'next/link'

export const MobileCategoryItem = ({ to, label, onClick, products }) => {
  return (
    <li>
      <Link
        scroll={false}
        href={to.store ? `/${to._type}s/${to.store.slug.current}` : ''}
        className="inline-block w-full rounded-8 bg-white p-8"
        onClick={onClick}
      >
        {products ? (
          <div className="grid grid-cols-6 gap-6">
            {products.map((product, i) => {
              return (
                <div
                  key={i}
                  className="relative aspect-[2/2.5] overflow-hidden rounded-6 bg-lightGray"
                >
                  <ResponsiveImage
                    src={`${product.imgUrl}&width=100`}
                    alt={product.title ?? ''}
                    sizes="50px"
                  />
                </div>
              )
            })}
          </div>
        ) : (
          <div className="grid grid-cols-6 gap-6">
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
            <div className="aspect-[2/2.5] rounded-6 bg-lightGray"></div>
          </div>
        )}
        <div className="pt-8">{label}</div>
      </Link>
    </li>
  )
}
